import path from 'ramda/src/path'
import pathOr from 'ramda/src/pathOr'
import is from 'ramda/src/is'
import { formModuleLenses } from 'root/src/client/logic/form/lenses'
import moduleDescriptions from 'root/src/shared/descriptions/modules'
import stepFormCurrentPage from 'root/src/client/logic/form/selectors/stepFormCurrentPage'
import orEmpty from 'root/src/shared/util/orEmpty'

const { viewSchema } = formModuleLenses

export default (state, props) => {
	const { moduleId, moduleKey, submitKey, stepId } = props
	const customSubmit = pathOr(
		undefined,
		[submitKey, 'schema'],
		path([moduleId, ...orEmpty(stepId, ['steps', stepId]), 'submits'], moduleDescriptions),
	)

	if (customSubmit) {
		return is(Function, customSubmit) ? customSubmit(state, props) : customSubmit
	}

	const schema = viewSchema(moduleId, moduleDescriptions)
	if (schema) {
		return schema
	}

	const stepFormPage = stepFormCurrentPage(state, { moduleKey })
	return path(['schema'], stepFormPage)
}
